import { Component, EventEmitter, Input, OnInit, Output, effect, signal } from '@angular/core'
import { count } from 'rxjs'

@Component({
  selector: 'app-password-input',
  templateUrl: './password-input.component.html',
  styleUrls: ['./password-input.component.scss']
})
export class PasswordInputComponent {
  @Input() isInValid = false
  @Output() passwordChange = new EventEmitter<string>()

  show = true
  password = ''

  togglePasswordVisibility() {
    this.show = !this.show
  }

  onPasswordInput() {
    this.passwordChange.emit(this.password)
  }
}
